<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel d-flex flex-column w-60pc">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ panelHeader }}</h2>
            </div>            
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning" (click)="onClosePanel()">
                    {{ 'Close' | translate }}
                </button>
            </div>
        </header>
        <div class="block padding-top-5 heightCalc-5">
            <div class="col-md-12 no-padding-right-left padding-top-15 heightCalc-14">                                                                 
                <app-grid [columns]="gridColumnDefs" [data]="lstClaimants" [gridConfigItems]="gridConfigItems">
                </app-grid>                   
            </div>
        </div>         
    </div>
</div>
